import { CountryCode } from "../../../api/Representation";
import LicenseType from "../../../enums/LicenseType";
export var RoleName;
(function (RoleName) {
    RoleName["SUBTRUX_ADMIN"] = "SUBTRUX_ADMIN";
    RoleName["SUBTRUX_ADMIN_ACCOUNTS"] = "SUBTRUX_ADMIN_ACCOUNTS";
    RoleName["TENANT_ADMIN"] = "TENANT_ADMIN";
    RoleName["DRIVER"] = "DRIVER";
    RoleName["API"] = "API";
    RoleName["HEALTH_API"] = "HEALTH_API";
    RoleName["OPERATIONS"] = "OPERATIONS";
    RoleName["OPERATIONS_MANAGER"] = "OPERATIONS_MANAGER";
    RoleName["CUSTOMER_SUPPORT_READ_ONLY"] = "CUSTOMER_SUPPORT_READ_ONLY";
    RoleName["CUSTOMER_SUPPORT_WITH_EDIT"] = "CUSTOMER_SUPPORT_WITH_EDIT";
    RoleName["CUSTOMER_USER"] = "CUSTOMER_USER";
    RoleName["MARKETPLACE_ADMIN"] = "MARKETPLACE_ADMIN";
    RoleName["MARKETPLACE_OPERATIONS"] = "MARKETPLACE_OPERATIONS";
    RoleName["MARKETPLACE_VIEW_ONLY"] = "MARKETPLACE_VIEW_ONLY";
    RoleName["DIVISIONAL"] = "DIVISIONAL";
    RoleName["FLEET_ADMIN"] = "FLEET_ADMIN";
    RoleName["DELIVERY_MANAGER"] = "DELIVERY_MANAGER";
    RoleName["SALES_PERSON"] = "SALES_PERSON";
})(RoleName || (RoleName = {}));
export var RoleTypeEnum;
(function (RoleTypeEnum) {
    RoleTypeEnum["SUPER_ADMIN"] = "SUPER_ADMIN";
    RoleTypeEnum["ADMIN"] = "ADMIN";
    RoleTypeEnum["API"] = "API";
    RoleTypeEnum["APP"] = "APP";
    RoleTypeEnum["CUSTOMER"] = "CUSTOMER";
})(RoleTypeEnum || (RoleTypeEnum = {}));
